import {
    AsyncPipe,
    isPlatformBrowser,
} from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    OnInit,
    output,
    PLATFORM_ID,
} from "@angular/core";
import {
    RouterLink,
    RouterLinkActive,
} from "@angular/router";
import {
    User,
    UserViewStatuses,
} from "@Front-end/seed/models/user";
import { RegistrationAnalyticInitSources } from "@Front-end/seed/modules/registration-v2";
import { UserDirective } from "@Front-end/seed/modules/user";
import { UserBalance } from "@Front-end/seed/utils/interfaces";
import {
    ModalOpenType,
    NgLetDirective,
} from "@Front-end/ui";
import { ClassOnScrollDirective } from "@Front-end/ui/directives/add-class-on-scroll";
import {
    ButtonV3KindDirective,
    ButtonV3PaletteDirective,
    ButtonV3SizeDirective,
} from "@Front-end/ui/modules/button-v3";
import { IconComponent } from "@Front-end/ui/modules/icon";
import { LocalizeRouterModule } from "@gilsdav/ngx-translate-router";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "../../../../../environments/environment";
import {
    FeatureFlags,
    hasFeatureFlag,
} from "../../../../constants/feature-flags.constants";
import { minMobileWidth } from "../../../../constants/media.constants";
import { StorageKeys } from "../../../../constants/storage.constants";
import { CheckEventThemePipe } from "../../../../pipes/check-event-theme.pipe";
import { SidePanelManagerService } from "../../../../services/side-panel-manager.service";
import { AppPopupsService } from "../../../../store/services/app-popups.service";
import { PictureComponent } from "../../../shared/picture/picture.component";
import { ProfileBalanceComponent } from "../../../shared/profile-balance/profile-balance.component";
import { ProfileComponent } from "../../../shared/profile/profile.component";

@Component({
    selector: "ls-header",
    imports: [
        TranslateModule,
        RouterLink,
        LocalizeRouterModule,
        AsyncPipe,
        RouterLinkActive,
        ProfileBalanceComponent,
        ProfileComponent,
        UserDirective,
        ButtonV3KindDirective,
        ButtonV3PaletteDirective,
        ButtonV3SizeDirective,
        ClassOnScrollDirective,
        IconComponent,
        CheckEventThemePipe,
        PictureComponent,
        NgLetDirective,
    ],
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        Document,
    ],
  })
export class HeaderComponent implements OnInit {
    constructor(
        private appPopupsService: AppPopupsService,
        private sidePanelManagerService: SidePanelManagerService,
    ) {
    }

    public readonly user = input<User | null>(null);
    public readonly isProfilePage = input<boolean>(false);
    public readonly balance = input<Partial<UserBalance> | null>();
    public readonly hideHeaderPromo = input<boolean>(false);

    public readonly lsToggleMenu = output<void>();

    public readonly userViewStatuses = UserViewStatuses;
    public logoBreakpoint = minMobileWidth;
    public eventTheme: string = environment.eventTheme;
    public cdn: string = environment.cdnUrl;
    public wasLoggedIn: boolean = false;
    public showSport: boolean = hasFeatureFlag(FeatureFlags.SPORT);
    public headerLinks = [
        {
            name: "common.category-casino",
            url: "/game-categories/popular",
        },
        {
            name: "common.live",
            url: "/game-categories/live-casino",
        },
        {
            name: "common.category-sport",
            url: this.showSport ? "/sport" : "",
        },
        {
            name: "common.category-shop",
            url: "/shop",
        },
        {
            name: "common.category-promotions",
            url: "/promotions",
        },
        {
            name: "common.vip",
            url: "/vip",
        },
    ];
    protected readonly document = inject(Document);
    protected readonly platformId = inject(PLATFORM_ID);
    public isMobileLogo: boolean = isPlatformBrowser(this.platformId) ? screen.width < this.logoBreakpoint : true;

    public ngOnInit(): void {
        this.wasLoggedIn = Boolean(isPlatformBrowser(this.platformId)
            ? this.document?.defaultView?.localStorage.getItem(StorageKeys.lsWasLoggedIn)
            : false);
    }

    public login(): void {
        this.appPopupsService.fireOpenLogin(ModalOpenType.MANUAL);
    }

    public registration(): void {
        this.appPopupsService.fireOpenRegistration({
            source: RegistrationAnalyticInitSources.HEADER,
        }, ModalOpenType.MANUAL);
    }

    public toggleMenu(): void {
        this.lsToggleMenu.emit();
    }

    public closeMenu(): void {
        this.sidePanelManagerService.closeRedirect();
    }
}
